export const POSITION_OPTIONS = [
  { value: 'bet-topline', label: 'Bet Top Line' },
  { value: 'avatar-header', label: 'Avatar Header' },
  { value: 'below-header', label: 'Below Header' },
  { value: 'above-content', label: 'Above Content' },
]

export const FONT_STYLE_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'italic', label: 'Italic' },
  { value: 'bold', label: 'Bold' },
  { value: 'bold-italic', label: 'Bold Italic' },
]

// optionLabel shows a stored tag value by its form label; an unknown value
// (an older or hand-written tag) is shown as stored.
export function optionLabel(options, value) {
  return options.find((option) => option.value === value)?.label || value || ''
}
